import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: () => import('../pages/login/index.vue'),
        },
        {
            path: '/',
            name: 'Layout',
            component: () => import('../pages/layout/index.vue'),
            children: [
                {
                    path: '',
                    redirect: '/prompt',
                },
                {
                    path: '/prompt',
                    component: () => import('../pages/prompt/index.vue'),
                },
                {
                    path: '/visual-prompt',
                    component: () => import('../pages/visualPromptList/index.vue'),
                },
                {
                    path: '/account',
                    component: () => import('../pages/account/index.vue'),
                },
                {
                    path: '/manual-points',
                    component: () => import('../pages/manualPoints/index.vue'),
                },
                {
                    path: '/optimize',
                    component: () => import('../pages/optimize/index.vue'),
                },
                {
                    path: '/channel',
                    component: () => import('../pages/channel/index.vue'),
                },
                {
                    path: '/active',
                    component: () => import('../pages/active/index.vue'),
                },
                {
                    path: '/achievement',
                    component: () => import('../pages/achievement/index.vue'),
                },
                {
                    path: '/config',
                    component: () => import('../pages/config/index.vue'),
                },
                {
                    path: '/rating',
                    component: () => import('../pages/rating/index.vue'),
                },
                {
                    path: '/gpts-task',
                    component: () => import('../pages/gptsTask/index.vue'),
                },
                {
                    path: '/gpts-list',
                    component: () => import('../pages/gptsList/index.vue'),
                },
                {
                    path: '/voucher',
                    component: () => import('../pages/voucher/index.vue'),
                },
                {
                    path: '/analytics',
                    component: () => import('../pages/analytics/index.vue'),
                    children: [
                        {
                            path: '/views-analytics',
                            component: () => import('../pages/analytics/views-analytics/index.vue'),
                        },
                        {
                            path: '/home-views-analytics',
                            component: () => import('../pages/analytics/home-views-analytics/index.vue'),
                        },
                        {
                            path: '/visual-views-analytics',
                            component: () => import('../pages/analytics/visual-views-analytics/index.vue'),
                        },
                        {
                            path: '/blog-views-analytics',
                            component: () => import('../pages/analytics/blog-views-analytics/index.vue'),
                        },
                        {
                            path: '/gpts-views-analytics',
                            component: () => import('../pages/analytics/gpts-views-analytics/index.vue'),
                        },
                        {
                            path: '/optimize-views-analytics',
                            component: () => import('../pages/analytics/optimize-views-analytics/index.vue'),
                        },
                        {
                            path: '/optimize-image-views-analytics',
                            component: () => import('../pages/analytics/optimize-image-views-analytics/index.vue'),
                        },
                        {
                            path: '/convert-rate-analytics',
                            component: () => import('../pages/analytics/convert-rate-analytics/index.vue'),
                        },
                        {
                            path: '/churn-rate-analytics',
                            component: () => import('../pages/analytics/churn-rate-analytics/index.vue'),
                        },
                    ],
                },
                {
                    path: '/blog',
                    component: () => import('../pages/blog/index.vue'),
                    children: [
                        {
                            path: '/placement-blog',
                            component: () => import('../pages/blog/placement-blog/index.vue'),
                        },
                        {
                            path: '/list-blog',
                            component: () => import('../pages/blog/list-blog/index.vue'),
                        },
                    ],
                },
            ],
        },
        {
            path: '*',
            redirect: '/',
        },
    ],
});

router.beforeEach((to, from, next) => {
    NProgress.start();
    next();
});

router.afterEach(() => {
    NProgress.done();
});

export default router;
